<template>

  <div class="card">
    <div v-if="!readonly" class="card-toolbar">
      <div class="main-actions">
        <button v-if="!readonly" class="main-btn main-btn-success" data-bs-toggle="modal"
                title="Novo Documento" :data-bs-target="'#modal_store_document_' + modalRecordId">
          <i class="bi bi-plus-lg"></i>
          <span>Novo Documento</span>
        </button>
      </div>
    </div>

    <div v-if="documents.length === 0" class="empty-state">
      <div class="empty-state-content">
        <div class="empty-state-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <path opacity="0.3" d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#780f5a"/>
            <path d="M14 2V8H20L14 2ZM18 20H6V4H13V9H18V20Z" fill="#780f5a"/>
            <path d="M12 14H8V16H12V14ZM16 10H8V12H16V10ZM8 6H16V8H8V6Z" fill="#780f5a"/>
          </svg>
        </div>
        <h3 class="empty-state-title">Nenhum documento</h3>
        <p class="empty-state-description" v-if="!readonly">
          Ainda não foi adicionado nenhum documento para este atendimento.<br>
          Clique no botão "Novo Documento" acima para começar.
        </p>
      </div>
    </div>

    <div class="document-card" v-for="document in documents" :key="document.id_document">
      <div class="document-header collapsible cursor-pointer rotate"
           data-bs-toggle="collapse" :data-bs-target="'#kt_document_card_collapsible_' + documentDomId(document.id_document)">
        <div class="document-title">
          <div class="document-icon">
            <span class="svg-icon svg-icon-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="currentColor"/>
                <path d="M14 2V8H20L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
              </svg>
            </span>
          </div>
          <div class="document-info">
            <h3 class="document-name">#{{document.id_document}} {{document?.document_name}}</h3>
            <span v-if="document.id_task_origin" class="badge bg-light-primary text-primary">Emissão avulsa · Tarefa #{{ document.id_task_origin }}</span>
            <div class="document-status">
              <span :title="document.document_generated?'Alteração bloqueada - PDF já gerado':'Liberado para alteração'" 
                    :class="document.document_generated?'status-icon locked':'status-icon unlocked'">
                <i :class="document.document_generated?'bi bi-lock-fill':'bi bi-unlock-fill'"></i>
              </span>
              <span v-if="document.document_generated" title="PDF gerado" class="status-icon pdf">
                <i class="bi bi-file-pdf-fill"></i>
              </span>
              <span v-if="document.document_signed" title="Assinado" class="status-icon signed">
                <i class="bi bi-pen-fill"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="document-toolbar rotate-180">
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
              <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="currentColor"></path>
            </svg>
          </span>
        </div>
      </div>
      <div :id="'kt_document_card_collapsible_' + documentDomId(document.id_document)" class="collapse show">
        <div class="document-actions">
          <div class="action-buttons">
            <button v-if="!readonly && document.document_generated" class="action-btn action-btn-warning action-btn-reopen"
                    title="Reabrir para Alteração" @click="reopenDocument(document.id_document)">
              <i class="bi bi-unlock-fill"></i>
              <span>Reabrir</span>
            </button>
            <button class="action-btn action-btn-info action-btn-print"
                    title="Imprimir" @click="showSelectCertifier(document)">
              <i class="bi bi-printer"></i>
              <span>{{ taskContext ? 'Emitir / assinar' : 'Imprimir' }}</span>
            </button>
            <button v-if="!readonly" class="action-btn action-btn-secondary" data-bs-toggle="modal"
                    :data-bs-target="'#modal_save_document_model_' + modalRecordId"
                    title="Salvar este documento como modelo"
                    @click="openSaveAsModel(document)">
              <i class="bi bi-bookmark-plus"></i>
              <span>Salvar</span>
            </button>
            <button v-if="!readonly" class="action-btn action-btn-danger action-btn-delete"
                    title="Excluir Documento" @click="deleteDocument(document.id_document)">
              <i class="bi bi-trash"></i>
              <span>Excluir</span>
            </button>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-7">
            <label class="fs-6 fw-bold form-label mt-3">
            <span>
             Texto do Documento
            </span>
            </label>
            <QuillEditor height="500"
                         :disabled="readonly || document.document_generated" :value="document.document_body"
                         class="form-control-solid"
                         @change="saveDocument($event, document.id_document, document.document_generated);"/>
          </div>
        </div>
      </div>

      <Teleport to="body">
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" :id="'modal_print_' + documentDomId(document.id_document)" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" v-if="messagesGenerateDocument.showBtnClose">
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                   data-bs-dismiss="modal" aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="col-md-12 mb-6 mt-4">
                <div class="text-center px-5" :key="messagesGenerateDocument.image">
                  <video width="200" height="200" :loop="messagesGenerateDocument.loop" autoplay playsinline muted v-if="messagesGenerateDocument.image.includes('.mp4')">
                    <source :src="messagesGenerateDocument.image" type="video/mp4" />
                  </video>
                  <img v-else-if="messagesGenerateDocument.image" :src="messagesGenerateDocument.image" alt="Imagem" class="mw-100 h-200px h-sm-325px">
                  <p v-html="messagesGenerateDocument.message"></p>
                </div>
              </div>
            </div>
            <div class="modal-footer" v-if="messagesGenerateDocument.showBtnClose">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
  </Teleport>

    </div>
  </div>

  <Teleport to="body">
<div class="modal fade" tabindex="-1" :id="'modal_store_document_' + modalRecordId">
    <div class="modal-dialog modal-lg">
      <form method="post" @submit.prevent="submitFormStore">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Novo Documento</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <p v-if="taskContext" class="alert alert-primary py-3"><strong>{{ taskContext.patientName }}</strong> · Emissão avulsa vinculada ao atendimento de {{ taskContext.recordDate }}.</p>
            <div class="d-flex gap-2 mb-4">
              <button type="button" class="btn btn-sm" :class="!fromPrevious ? 'btn-primary' : 'btn-light'" @click="fromPrevious = false">Em branco ou modelo</button>
              <button type="button" class="btn btn-sm" :class="fromPrevious ? 'btn-primary' : 'btn-light'" @click="fromPrevious = true">Usar documento anterior</button>
            </div>
            <PreviousDocumentPicker v-if="fromPrevious" :professional-id="schedule.id_prof" :patient-id="schedule.id_patient"
              :record-id="medicalRecord.id_medrec" :task-context="taskContext" kind="documents" @created="onPreviousCopied" @empty="fromPrevious = false" />
            <template v-else>
            <div class="col-md-12 mb-6 mt-4">
              <label for="type_store" class="form-label">Modelo</label>
              <div class="d-flex gap-2 align-items-start">
                <select class="form-control form-select" id="type_store"
                        aria-label="Selecione o modelo" v-model="formStore.id_doctempl" @change="setDocumentTemplate($event.target.selectedIndex);">
                  <option value="" selected>--Nenhum--</option>
                  <option :value="documentTemplate.id_doctempl" v-for="documentTemplate in documentTemplates" :key="documentTemplate.id_doctempl">
                    {{ documentTemplate.doctempl_name }}
                  </option>
                </select>
                <button type="button"
                        class="btn btn-light-primary text-nowrap"
                        v-if="canFillWithAi"
                        :disabled="aiFillLoading"
                        @click="fillWithAi">
                  <span v-if="aiFillLoading" class="spinner-border spinner-border-sm me-1"></span>
                  <i v-else class="bi bi-stars me-1"></i>
                  Preencher com IA
                </button>
              </div>
              <small class="text-muted d-block mt-1" v-if="canFillWithAi">
                A IA usa o histórico do prontuário do paciente. Revise o texto antes de cadastrar.
              </small>
              <small class="text-danger" v-if="formStoreErrors.id_doctempl">{{ formStoreErrors.id_doctempl[0] }}</small>
            </div>
            <div class="col-md-12 mb-6 mt-4">
              <label for="document_name_store" class="required form-label">Descrição</label>
              <input class="form-control form-control-solid"
                     v-model="formStore.document_name" id="document_name_store" autofocus required>
              <small class="text-danger" v-if="formStoreErrors.document_name">{{ formStoreErrors.document_name[0] }}</small>
            </div>
            <div class="col-md-12">
              <div class="mb-7">
                <label class="fs-6 fw-bold form-label mt-3">
            <span>
            Texto do Documento <span class="text-danger">*</span>
            </span>
                </label>
                <QuillEditor height="500"
                             :key="documentEditorKey"
                             required="true" :value="formStore.document_body"
                             class="form-control-solid" :options="{'placeholder': 'Digite aqui... '}"
                             @change="formStore.document_body = $event.html"/>
              </div>
            </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button v-if="!fromPrevious" type="submit" class="btn btn-primary">Cadastrar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </Teleport>

  <PdfViewer :id="'modal_pdf_viewer_document_' + this.modalRecordId"
             :pdf-source="this.pdfSource"
             :file-name="this.fileName"
             :signed="this.signed"
             :key="'Document:'+ modalRecordId"
             :delivery="documentsDelivery"
             @edit-contact="openPatientContact"/>

  <SelectCertifier :id="'modal_certifier_document_' + this.modalRecordId"
                   :certifiers="this.certifiers"
                   :key="'DocumentCertifier:'+ modalRecordId"
                   @onSelect="printDocument"/>


  <SaveAsModelModal :id-modal="'modal_save_document_model_' + modalRecordId"
                    title="Salvar documento como modelo"
                    hint="O modelo fica disponível na criação de novos documentos, já com o texto."
                    :summary="saveAsModelSummary"
                    :suggestion="saveAsModelSuggestion"
                    :saving="savingAsModel"
                    @save="saveDocumentAsModel"/>

</template>

<script>
import PreviousDocumentPicker from '../shared/PreviousDocumentPicker.vue';
import { taskDocumentParams, taskDocumentLinked } from '@/views/tasks/taskDocumentContext';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import http from "../../../helpers/http";
import Alert from "../../../helpers/alert";
import QuillEditor from "vue-quill-editor/src/editor";
import OS from "../../../helpers/os";
import Base64 from "../../../helpers/base64";
import PdfViewer from "../shared/PdfViewer";
import Config from "../../../config";
import SelectCertifier from "../../../components/SelectCertificator";
import SaveAsModelModal from "../../../components/SaveAsModelModal";
import documentsDelivery from "../shared/documentsDelivery";
import {confirmarAssinaturaSemSelo} from "../shared/signatureSealWarning";

export default {
  name: "Document",
  emits: ['signed', 'onModelSaved', 'edit-patient-contact'],
  mixins: [documentsDelivery],
  components: {
    PreviousDocumentPicker,
    QuillEditor,
    PdfViewer,
    SelectCertifier,
    SaveAsModelModal,
  },
  props: {
    taskContext: { type: Object, default: null },
    schedule: Object,
    medicalRecord: Object,
    documentTemplates: Array,
    readonly: Boolean,
    certifiers: Array,
  },
  data() {
    return {
      fromPrevious: false,
      currentDocumentId: '',
      attributeDocument: '',
      documents: [],
      formStore: {
        id_medrec: '',
        document_name: '',
        id_doctempl: '',
        document_body: '',
      },
      formStoreErrors: [],
      saveAsModelSource: null,
      saveAsModelSuggestion: '',
      saveAsModelSummary: '',
      savingAsModel: false,
      aiFillLoading: false,
      documentEditorKey: Date.now().toString(),
      messagesGenerateDocument: {
        message: '',
        image: '',
        showBtnClose: false,
      },
      pdfSource: '',
      fileName: '',
      signed: false,
      selectedDocument: '',
    }
  },
  computed: {
    modalRecordId() { return this.medicalRecord.id_medrec + (this.taskContext ? '_task_' + this.taskContext.id : ''); },
    userAuth() {
      return this.$store.state.auth.user;
    },
    place() {
      return this.$store.state.auth.place;
    },
    selectedDocumentTemplate() {
      if (!this.formStore.id_doctempl) {
        return null;
      }

      return (this.documentTemplates || []).find(
        (template) => Number(template.id_doctempl) === Number(this.formStore.id_doctempl)
      ) || null;
    },
    canFillWithAi() {
      return !!this.selectedDocumentTemplate?.doctempl_ai_fill;
    },
  },
  mounted() {
    this.documents = this.taskContext ? [] : (this.medicalRecord.documents || []);
    if (this.taskContext) {
      this.getDocuments().then(() => {
        if (!this.documents.length && !this.taskContext.quick) this.$nextTick(() => bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_store_document_' + this.modalRecordId)).show());
      }).catch(error => Alert.toastError(error.response?.data?.message || 'Não foi possível carregar os documentos.'));
    } else {
      this.getDocuments();
    }
  },
  methods: {
    documentDomId(id) { return id + (this.taskContext ? '_task_' + this.taskContext.id : ''); },
    async onPreviousCopied(result) {
      await this.getDocuments();
      bootstrap.Modal.getInstance(document.getElementById('modal_store_document_' + this.modalRecordId))?.hide();
      this.fromPrevious = false;
      if (result?.certifier) {
        const copy = this.documents.find(item => Number(item.id_document) === Number(result.document.id_document));
        if (!copy) return;
        await this.$nextTick();
        this.selectedDocument = copy;
        await this.printDocument(result.certifier);
      }
    },
    openSaveAsModel(document) {
      this.saveAsModelSource = document;
      this.saveAsModelSuggestion = document.document_name ?? '';
      this.saveAsModelSummary = this.hasBody(document)
          ? 'O texto atual do documento será salvo no modelo.'
          : 'Este documento ainda não tem texto para salvar.';
    },
    hasBody(document) {
      return (document?.document_body ?? '').replace(/<[^>]*>/g, '').trim().length > 0;
    },
    saveDocumentAsModel(name) {
      const document = this.saveAsModelSource;

      if (!document || !this.hasBody(document)) {
        Alert.toastError('Escreva o texto do documento antes de salvar como modelo.');

        return;
      }

      this.savingAsModel = true;

      http.post(`/professionals/${this.medicalRecord.id_prof}/document-templates`, {
        doctempl_name: name,
        doctempl_body: document.document_body,
        doctempl_active: true,
      }).then(() => {
        Alert.toastSuccess('Modelo salvo. Ele já aparece na criação de novos documentos.');
        this.$emit('onModelSaved');
        bootstrap.Modal.getInstance(window.document.getElementById('modal_save_document_model_' + this.modalRecordId)).toggle();
      }).catch((e) => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível salvar o modelo.');
      }).finally(() => {
        this.savingAsModel = false;
      });
    },
    showSelectCertifier(documentModel) {
      this.selectedDocument = documentModel;

      if (!documentModel.document_signed) {
        let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_certifier_document_' + this.modalRecordId));
        modal.toggle();
      } else {
        this.printDocument(null);
      }
    },
    async printDocument(certifier) {
      this.fileName;

      let documentModel = this.selectedDocument;

      const seguir = await confirmarAssinaturaSemSelo({
        generated: documentModel?.document_generated,
        signed: documentModel?.document_signed,
        certifier,
      });

      if (!seguir) {
        return;
      }

      let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_print_' + this.documentDomId(documentModel.id_document)));
      modal.toggle();

      this.messagesGenerateDocument = {
        message: 'Gerando documento, por favor, aguarde...',
        image: require('@/assets/mp4/8558-floating-document.mp4'),
        showBtnClose: false,
      }

      const taskParams = taskDocumentParams(this.$route, 'document', this.medicalRecord, this.taskContext);
      return http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/${documentModel.id_document}/print`, { ...taskParams, certifier_id: certifier?.id ?? null }).then(async (response) => {
        taskDocumentLinked(taskParams);
        await new Promise(r => setTimeout(r, 1000));

        this.getDocuments();

        this.messagesGenerateDocument = {
          message: 'Baixando Documento ...',
          image: require('@/assets/mp4/97795-download-green.mp4'),
          showBtnClose: false,
        }

        let data = response.data;

        this.fileName  = data.authenticator.file.file_name;
        this.signed  = data.document.document_signed;

        await new Promise(r => setTimeout(r, 1200));

        if (data.document.document_generated && (data.document.document_signed || !certifier || certifier?.id === null || certifier?.id === "none")) {
          return this.showPdfViewer( `data:application/pdf;base64,${data.file_base64}`, data.authenticator.file.file_name, data.document.document_signed , modal);
        }

        if (certifier.id === "vidaas") {
          await this.signCloud(documentModel, certifier, modal,  data.authenticator.file.file_name);
        }

        if (certifier.id === "token") {
          modal.toggle();
          await this.signToken(data, documentModel, modal);
        }

      }).catch((e) => {
        this.messagesGenerateDocument = {
          message: e.response?.data,
          image: require('@/assets/mp4/4386-connection-error.mp4'),
          showBtnClose: true,
        }
      });
    },
    async signCloud(documentModel, certifier, modal, filename) {
      this.messagesGenerateDocument = {
        message: 'Assinando digitalmente...' + '\n' +
            'Para concluir, caso seja solicitado, autorize a transação no aplicativo em seu celular.\n' +
            'A liberação do seu celular é válida por 24 horas. Dentro desse período, você não precisará repetir esta etapa.',
        image: require('@/assets/mp4/signing.mp4'),
        showBtnClose: false,
        loop: true,
      };

      await http.post(`${certifier.url}/document/${documentModel.id_document}`).then(async (response) => {
        let data = response.data;
        this.getDocuments();
        this.showPdfViewer(`data:application/pdf;base64,${data.base64_signed}`, filename, true, modal);
      }).catch((e) => {
        modal.toggle();
        Alert.toastError('Erro ao assinar documento');
        this.messagesGenerateDocument = {
          message: e.response.data,
          image: require('@/assets/mp4/4386-connection-error.mp4'),
          showBtnClose: true,
        }
      });
    },    
    async signToken(fileToBeSign, documentModel, modal) {

      if (!window.WebSocket) {
        Alert.toastError('Seu navegador não tem suporte a conexão websocket.');
        return;
      }

      let certificatePassword = sessionStorage.getItem('certificate_password');
      if (!certificatePassword) {

        const { value: password } = await Swal.fire({
          title: 'Senha do certificado',
          input: 'text',
          inputLabel: 'Informe a senha',
          confirmButtonText: 'Assinar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#780f5a',
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return 'Informe a senha do certificado digital!'
            }
          }
        });

        if (password)
          certificatePassword = Base64.encode(password);

        if (!certificatePassword)
          return;
      }

      modal.toggle();

      this.messagesGenerateDocument = {
        message: 'Assinando digitalmente ...',
        image: require('@/assets/mp4/signing.mp4'),
        showBtnClose: false,
        loop: true,
      };

      let certificate = null;

      if (OS.getOS() === 'Windows') {
        let wsCertificates = new WebSocket(Config.protocol_ws + '://localhost:8044/certificates');
        wsCertificates.onopen = () => {
          wsCertificates.send('1');
        }

        wsCertificates.onmessage = async (event) => {
          let certificatesRaw = JSON.parse(event.data);
          wsCertificates.close(1000);

          if (certificatesRaw.length <= 0) {
            this.messagesGenerateDocument.showBtnClose = true;
            Alert.toastError('Nenhum certificado encontrado.');
            return;
          }

          let certificates = certificatesRaw.sort((certificateOne, certificateTwo) => {
            let expiryDateOne = new Date(certificateOne.expiryDate.toUpperCase().replace("BRT", "GMT-0300"));
            let expiryDateTwo = new Date(certificateTwo.expiryDate.toUpperCase().replace("BRT", "GMT-0300"));

            return expiryDateTwo - expiryDateOne;
          });

          if (certificates.length === 1) {
            certificate = certificates.alias;
            return;
          }

          let alias = certificates.map(a => a.alias);

          const { value: aliasSelected } = await Swal.fire({
            title: 'Certificados instalados',
            input: 'select',
            inputOptions: {
              alias
            },
            inputPlaceholder: 'Selecione um certificado',
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (value !== null) {
                  resolve();
                } else {
                  resolve('Selecione um certificado.');
                }
              });
            }
          });

          certificate = aliasSelected;
        }

        wsCertificates.onerror = () => {
          this.messagesGenerateDocument.showBtnClose = true;
          Swal.fire({
            title: "Opsss",
            text: "Não conseguimos identificar o Assinador Ubbimed instalado.",
            icon: "warning",
            confirmButtonText: 'OK',
            confirmButtonColor: '#780f5a',
          }).then(() => {
            window.open('/assinador/download')
          });
        }
      }

      let connectedPdfSign = false;
      let wsSignConnection = new WebSocket('ws://localhost:8044/pdf/sign');
      wsSignConnection.onopen =  () => {
        connectedPdfSign = true;
        let dataToBeSign = {
          certificate_pfx_as_base64: null,
          certificate_password: Base64.decode(passwordCertificate),
          reason: 'Assinatua de documentos Ubbimed.',
          location: this.place.place_name,
          contact: `${this.userAuth.user_name} <${this.userAuth.user_email}>`,
          certificate_alias: certificate,
          file_id: documentModel.id_document,
          file_as_base64: fileToBeSign.file_base64
        };

        wsSignConnection.send(JSON.stringify(dataToBeSign));
      }

      wsSignConnection.onmessage = (message) => {
        let responseSignature = JSON.parse(message.data);
        const file = Base64.str2Blob(responseSignature.file_signed_as_base64)
        const formData = new FormData();
        formData.append('file', file, 'file.pdf')

        let url = `/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/${documentModel.id_document}/upload-signed`;
        http.post(url, formData).then((response) => {
          Alert.toastSuccess('Assinatura realizada com sucesso.')

          this.showPdfViewer(`data:application/pdf;base64,${data.file_base64}`,  data.authenticator.file.file_name, true, modal);

          if (!sessionStorage.getItem('certificate_password')) {
            Swal.fire({
              text: 'Quer salvar a senha para nas próximas assinaturas?',
              icon: 'success',
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: 'Sim, salvar senha',
            }).then(async (result) => {
              if (result.isConfirmed) {
                sessionStorage.setItem('certificate_password', passwordCertificate);
              }
            });
          }
        });

        wsSignConnection.close(1000);
      }

      wsSignConnection.onerror = (error) => {
        Swal.close();
        if (connectedPdfSign) {
          this.messagesGenerateDocument = {
            message: 'Ocorreu um erro inesperado com o assinador Ubbimed. (' + error.code + ')',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        } else {
          this.messagesGenerateDocument = {
            message: 'Não foi possível estabelecer uma conexão com o assinador. ' +
                '<br><br>Verifique se o assinador Ubbimed está instalado ou se o mesmo está em execução na sua máquina.',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        }
      }

      wsSignConnection.onclose = (error) => {
        if (error.code === 1006) {
          this.messagesGenerateDocument = {
            message: 'Falha na comunição com o assinador.',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        } else if (error.code === 1011) {
          this.messagesGenerateDocument = {
            message: error.reason,
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        }
      }
    },
    getDocuments() {
      if (this.schedule == null)
        return;

      return http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents`).then((response) => {
        this.documents = this.taskContext ? response.data.filter(item => Number(item.id_task_origin) === Number(this.taskContext.id)) : response.data;
      });
    },
    setDocumentTemplate(index) {
      this.formStore.document_name = index === 0 ? '' : this.documentTemplates[index - 1].doctempl_name;
      if (index === 0) {
        this.formStore.document_body = '';
        this.documentEditorKey = Date.now().toString();
        return;
      }

      http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/merge-attributes/${this.documentTemplates[index - 1].id_doctempl}`).then((response) => {
        this.formStore.document_body = response.data;
        this.documentEditorKey = Date.now().toString();
      });
    },
    fillWithAi() {
      if (!this.formStore.id_doctempl || this.aiFillLoading) {
        return;
      }

      this.aiFillLoading = true;
      http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/ai-fill/${this.formStore.id_doctempl}`)
        .then((response) => {
          this.formStore.document_body = response.data;
          this.documentEditorKey = Date.now().toString();
          Alert.toastSuccess('Documento preenchido com IA. Revise antes de cadastrar.');
        })
        .catch((e) => {
          Alert.toastError(e.response?.data?.message ?? e.response?.data);
        })
        .finally(() => {
          this.aiFillLoading = false;
        });
    },
    submitFormStore() {
      this.formStore.id_medrec = this.medicalRecord.id_medrec;
      this.formStoreErrors = [];
      http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents`, { ...this.formStore, id_doctempl: this.formStore.id_doctempl || null, ...taskDocumentParams(this.$route, 'document', this.medicalRecord, this.taskContext) }).then(_ => {
        this.getDocuments();
        this.formStore = {
          id_medrec: '',
          document_name: '',
          id_doctempl: '',
          document_body: '',
        };
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_store_document_' + this.modalRecordId)).toggle();
        Alert.toastSuccess("Documento cadastrado com sucesso.");
      }).catch(e => {
        Alert.toastError(e.response.data.message??e.response.data);
        if (e.response.data.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      });
    },
    deleteDocument(documentId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o documento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/${documentId}`).then(_ => {
            this.getDocuments();
            Alert.toastSuccess("Documento excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    saveDocument(event, documentId, documentGenerated) {
      if (this.readonly || documentGenerated)
        return;

      const html = event.html;
      let url = `/professionals/${this.schedule?.id_prof}/patients/${this.schedule?.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/${documentId}`;
      http.put(url, {'document_body': html}).then((_) => {

      }).catch((_) => {
        Alert.toastError("Erro ao salvar documento.");
      });
    },
    reopenDocument(documentId) {
      Swal.fire({
        title: 'Heeyy',
        text: "A reabertura irá cancelar o PDF que já foi gerado. Tem certeza que deseja reabrir o documento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, reabrir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents/${documentId}/reopen`).then(_ => {
            this.getDocuments();
            Alert.toastSuccess("Documento reaberto com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    showPdfViewer(pdfSource,fileName, signed, modalOri) {
      this.loadDocumentsDelivery();

      this.pdfSource = pdfSource;
      this.fileName = fileName;
      this.signed = signed;
      if (signed) this.$emit('signed');
      modalOri.toggle();
      let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_pdf_viewer_document_' + this.modalRecordId));
      modal.toggle();
    },
  },
}
</script>

<style scoped>
/* Card principal de documento */
.document-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(120, 15, 90, 0.08);
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.document-card:hover {
  box-shadow: 0 4px 16px rgba(120, 15, 90, 0.12);
}

/* Header do documento */
.document-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-bottom: 2px solid #780f5a;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.document-header:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-bottom-color: #6a0d4e;
}

.document-title {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.document-icon {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.document-icon .svg-icon {
  color: #6c757d;
}

.document-info {
  flex: 1;
}

.document-name {
  color: #495057;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.document-status {
  display: flex;
  gap: 8px;
  align-items: center;
}

.status-icon {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.status-icon:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

.status-icon.locked {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.status-icon.unlocked {
  background: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.status-icon.pdf {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.status-icon.signed {
  background: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.document-toolbar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 10px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
}

.document-toolbar:hover {
  background: #e9ecef;
  border-color: #780f5a;
  transform: scale(1.05);
}

.document-toolbar .svg-icon {
  color: #6c757d;
  font-size: 1.2rem;
}

.document-toolbar:hover .svg-icon {
  color: #780f5a;
}

/* Toolbar principal */
.card-toolbar {
  background: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 20px 20px 0;
  border-radius: 12px 12px 0 0;
}

.main-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.main-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #ffffff;
  color: #666666;
}

.main-btn:hover {
  border-color: #780f5a;
  color: #780f5a;
  box-shadow: 0 2px 8px rgba(120, 15, 90, 0.15);
}

.main-btn-primary {
  background: #780f5a;
  color: white;
  border-color: #780f5a;
}

.main-btn-primary:hover {
  background: #6a0d4e;
  border-color: #6a0d4e;
  color: white;
}

.main-btn-success {
  background: #50cd89;
  color: white;
  border-color: #50cd89;
}

.main-btn-success:hover {
  background: #47be7d;
  border-color: #47be7d;
  color: white;
  box-shadow: 0 2px 8px rgba(80, 205, 137, 0.25);
}

/* Ações do documento */
.document-actions {
  background: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 20px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Telas estreitas: em linha os botoes quebravam em larguras desiguais, com o
   ultimo sozinho. Em grade eles ficam do mesmo tamanho e alinhados. */
@media (max-width: 767.98px) {
  .action-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .action-btn {
    justify-content: center;
    text-align: center;
    padding: 10px 12px;
    line-height: 1.25;
  }
}

/* So empilha em uma coluna quando duas nao cabem mais: a 414px quatro botoes
   em coluna gastam meia tela de altura. */
@media (max-width: 359.98px) {
  .action-buttons {
    grid-template-columns: 1fr;
  }
}


.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #ffffff;
  color: #666666;
}

.action-btn:hover {
  border-color: #780f5a;
  color: #780f5a;
  box-shadow: 0 2px 6px rgba(120, 15, 90, 0.15);
}

.action-btn-warning {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-warning:hover {
  background: #e9ecef;
  border-color: #780f5a;
  color: #780f5a;
}

.action-btn-info {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-info:hover {
  background: #e9ecef;
  border-color: #780f5a;
  color: #780f5a;
}

.action-btn-danger {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-danger:hover {
  background: #e9ecef;
  border-color: #dc3545;
  color: #dc3545;
}

/* Botão de impressão destacado */
.action-btn-print {
  color: #780f5a;
  border: 1px solid #780f5a;
}

.action-btn-print:hover {
  color: #6a0d4e;
  border-color: #6a0d4e;
}

/* Botão de exclusão destacado */
.action-btn-delete {
  color: #dc3545;
  border: 1px solid #dc3545;
}

.action-btn-delete:hover {
  color: #c82333;
  border-color: #c82333;
}

/* Botão de reabertura destacado */
.action-btn-reopen {
  color: #0d6efd;
  border: 1px solid #0d6efd;
}

.action-btn-reopen:hover {
  color: #0b5ed7;
  border-color: #0b5ed7;
}

/* Estado vazio */
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 20px 0;
}

.empty-state-content {
  text-align: center;
  max-width: 400px;
}

.empty-state-icon {
  margin-bottom: 24px;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
}

.empty-state-title {
  color: #780f5a;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-shadow: 0 2px 4px rgba(120, 15, 90, 0.1);
}

.empty-state-description {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  font-weight: 400;
}

/* Animação flutuante para o ícone */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
